import merge from 'latest_modules/lodash/merge';
import axios from './common/axios';

export default {
  getThreads(url, options, callback) {
    const data = merge({
      url
    }, options);
    axios
      .post('/comments/list', data)
      .then(function(res) {
        if (res.status !== 200) {
          return callback(new Error(404));
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  postComment(threadId, comment, options, callback) {
    const data = merge({
      id: threadId,
      comment
    }, options);
    axios
      .post('/comments/post', data)
      .then(function(res) {
        if (res.status !== 200) {
          return callback(new Error(404));
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  postEditComment(threadId, commentId, comment, options, callback) {
    const data = merge({
        id: threadId,
        commentId,
        comment
      },
      options
    );
    axios
      .post('/comments/post', data)
      .then(function(res) {
        if (res.status !== 200) {
          return callback(new Error(404));
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  deleteComment(commentId, options, callback) {
    const data = merge({
      id: commentId
    }, options);
    axios
      .post('/comments/delete', data)
      .then(function(res) {
        if (res.status !== 200) {
          return callback(new Error(404));
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  postReply(commentId, comment, options, callback) {
    const data = merge({
      id: commentId,
      comment
    }, options);
    axios
      .post('/comments/reply', data)
      .then(function(res) {
        if (res.status !== 200) {
          return callback(new Error(404));
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  postReport(commentId, text, options, callback) {
    const data = merge({
      id: commentId,
      text
    }, options);
    axios
      .post('/comments/report', data)
      .then(function(res) {
        if (res.status !== 200) {
          return callback(new Error(404));
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  postMarkAsSpam(commentId, options, callback) {
    const data = merge({
      id: commentId
    }, options);
    axios
      .post('/comments/spam', data)
      .then(function(res) {
        if (res.status !== 200) {
          return callback(new Error(404));
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  }
};
